<template>
	<div>
		<vuetable ref="vuetable" :api-url="apiURL" :fields="fields"
			pagination-path="meta"
			:append-params="filters"
			:http-fetch="fetch"
			@vuetable:row-clicked="rowClick"
			@vuetable:checkbox-toggled="checkboxToggled"
            @vuetable:pagination-data="onPaginationData"

		></vuetable>
		<Pagination ref="pagination" @vuetable-pagination:change-page="onChangePage"></Pagination>

		<div class="list__empty" v-if="empty">

		</div>
	</div>
</template>

<script>
	import Vue from 'vue';
	import Vuetable from 'vuetable-2/src/components/Vuetable';
	import debounce from 'debounce';
	import Pagination from "./Pagination";
    import FilterableList from './List';


	// import ColumnFileName from './ColumnFileName';
	// import ColumnFileActions from './ColumnFileActions';

	import ColumnPostTitle from "./ColumnPostTitle";
	import ColumnPostStatus from "./ColumnPostStatus";
	import ColumnPostActions from "./ColumnPostActions";
	import ColumnPostAuthors from "./ColumnPostAuthors";

	Vue.component('column-posttitle', ColumnPostTitle);
	Vue.component('column-poststatus', ColumnPostStatus);
	Vue.component('column-postactions', ColumnPostActions);
	Vue.component('column-postauthors', ColumnPostAuthors);

	export default {
		name: 'ListFiles',
		components: {
			Vuetable,
            Pagination
		},
		props: ['filters'],
		watch: {
			filters: {
				deep: true,
				handler() {
					this.debounceReload();
				}
			}
		},
		data() {
			return {
				empty: false,
                apiURL: '/api/user/posts',
				fields: [
					{
						name: '__component:column-posttitle',
						sortField: 'title',
						title: 'Title'
					},
					{
						name: '__component:column-poststatus',
						sortField: 'status',
						title: 'Status',
						width: '200px'
					},
					{
						name: '__component:column-postauthors',
						title: 'Authors',
						width: '200px'
					},
					{
						name: 'group.name',
						sortField: 'group',
						title: 'Group',
                        dataClass: "post-group"
					},
					// {
					// 	name: '__component:column-postactions',
					// 	title: 'Actions',
					// 	width: '200px'
					// },
				],
			};
		},
		created(){
			//Set this during component creation to avoid multiple components sharing the same debounce
			this.debounceReload = debounce(function() {
				this.$refs.vuetable.reload();
			}, 250);
		},
		methods: {
			debounceReload() {},
			formatDate: value => value ? format(value, 'DD/MM/YY') : 'Never',
			onPaginationData(paginationData) {
				this.$refs.pagination.setPaginationData(paginationData)
			},
			onChangePage(page) {
				this.$refs.vuetable.changePage(page)
			},
			onRowClass(dataItem, index) {
			},
			onLoading() {},
			onLoaded() {
				if(this.$refs.vuetable.displayEmptyDataRow) {
					this.empty = true;
				}
			},
			onLoadError() {},
			fetch(apiUrl, httpOptions) {
				this.error = false;
				this.loaded = false;
				this.loading = true;
				this.empty = false;

				return axios.get(apiUrl, httpOptions)
					.then((response) => {
						this.loaded = true;

						if(response.data && Array.isArray(response.data.data) && !response.data.data.length) {
							this.empty = true;
						}

						this.$emit('breadcrumbs-update', response.data.breadcrumbs);

						return response;
					})
					.catch(() => {
						this.error = true;
						this.$refs.vuetable.resetData();
					})
					.finally(() => {
						this.loading = false;
					});
			},
			load(force) {
				if(!force && (this.loaded || this.loading)) {
					return;
				}

				this.$refs.vuetable.reload();
			},
			rowClick(data){
			},
			checkboxToggled(isChecked, post){
				if(isChecked){
					this.$emit('selected-post', post);
				}else{
					this.$emit('deselected-post', post);
				}
			}
		}
	}
</script>
<style lang="scss">
    .post-title{
        font-size: 14px;
        font-weight: bold;
    }
</style>
